"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToOption = void 0;
var _react = require("react");
var useToOption = exports.useToOption = function useToOption(_ref) {
  var isOptionDisabled = _ref.isOptionDisabled,
    isOptionFocused = _ref.isOptionFocused,
    isOptionSelected = _ref.isOptionSelected,
    onOptionHover = _ref.onOptionHover,
    onOptionSelect = _ref.onOptionSelect,
    renderOption = _ref.renderOption,
    selectedOptions = _ref.selectedOptions,
    inputValue = _ref.inputValue;
  var initialSelectedOptions = (0, _react.useRef)({});
  return (0, _react.useCallback)(function (option, i) {
    var selected = isOptionSelected(option);
    var disabled = isOptionDisabled ? isOptionDisabled(option, selectedOptions) : option.disabled;
    var focused = isOptionFocused(option);
    var onHover = focused ? undefined : function () {
      onOptionHover(option);
    };
    var onSelect = function onSelect() {
      return onOptionSelect(option);
    };
    var optionId = "option-".concat(i);
    if (initialSelectedOptions.current[i] === undefined) {
      initialSelectedOptions.current[i] = selected;
    }
    return {
      type: 'option',
      key: optionId,
      data: option,
      selected: selected,
      focused: focused,
      disabled: disabled,
      isButton: true,
      render: function render() {
        return renderOption(option, {
          selected: selected,
          disabled: disabled,
          initialSelected: initialSelectedOptions.current[i],
          focused: focused,
          index: i
        });
      },
      innerProps: {
        id: optionId,
        onClick: onSelect,
        onMouseMove: onHover,
        onMouseOver: onHover,
        tabIndex: disabled ? null : -1
      }
    };
  }, [renderOption, selectedOptions, inputValue, isOptionDisabled, isOptionSelected, isOptionFocused, onOptionHover, onOptionSelect]);
};